import React from 'react';
import { Info } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Button } from '@/ui-kit/button';
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/ui-kit/tooltip';

interface OnboardingInfoIconProps {
  content: string;
  /** Prevent accordion trigger toggle when nested inside AccordionTrigger. */
  stopPropagation?: boolean;
  className?: string;
  side?: 'top' | 'right' | 'bottom' | 'left';
  align?: 'start' | 'center' | 'end';
}

export const OnboardingInfoIcon: React.FC<OnboardingInfoIconProps> = ({
  content,
  stopPropagation = false,
  className,
  side = 'top',
  align = 'center',
}) => {
  const handlePointerDown = (e: React.PointerEvent) => {
    if (stopPropagation) e.stopPropagation();
  };

  const handleClick = (e: React.MouseEvent) => {
    if (stopPropagation) e.stopPropagation();
  };

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          size="icon"
          className={cn('h-7 w-7 shrink-0 text-muted-foreground hover:text-foreground', className)}
          aria-label="More information"
          onPointerDown={handlePointerDown}
          onClick={handleClick}
        >
          <Info className="h-4 w-4" />
        </Button>
      </TooltipTrigger>
      <TooltipContent side={side} align={align} className="max-w-xs text-left">
        <p>{content}</p>
      </TooltipContent>
    </Tooltip>
  );
};

interface OnboardingInfoProviderProps {
  children: React.ReactNode;
}

export const OnboardingInfoProvider: React.FC<OnboardingInfoProviderProps> = ({ children }) => (
  <TooltipProvider delayDuration={200}>{children}</TooltipProvider>
);
